<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="line-icon">
    <path d="M3 17l6-6 4 4 8-8M15 7h6v6" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#4555CC',
    },
  },
};
</script>

<style lang="scss" scoped>
.line-icon {
  flex: none;
}
</style>
